<template>
  <div id="boost-projekt" class="animated fadeIn pb4">
    <!-- desktop view -->
    <div>
      <WebshopHeader class="hide">
      </WebshopHeader>
      <div class="py4 px3">
        <div class="pt2"></div>
        <h4 class="darkblue bold">Boost et projekt</h4>
        <p class="gibson mediumgrey"></p>
        <div class="py3">
          <div class="p0">
            <div class="clearfix" v-if="insideLoading">
              <div class="col-12">
                <div class="loader"></div>
              </div>
            </div>
            <div v-else>
              <div class="col-12 p0 flex flex-wrap" v-if="projMsg == ''">
                <div class="lg-col-3 md-col-12 pl0 pb2 pr3 mb4" v-for="(proj,index) in projData" :key="index">
                  <div class="overflow-hidden flex">
                  <span :data-key="index" ref="text" class="h5 darkblue bold text-overflow-handle" @click="showlesss(index)">{{proj.title}}</span>
                  </div>
                  <div class="pb2"></div>
                  <el-collapse class="border-none">
                    <el-collapse-item title="Billede & Beskrivelse" :name="index">
                      <div v-if="proj.images.length">
                       <img :src="proj.images[0].image" width="100%">
                      </div>
                      <div class="pb2"></div>
                      <p class="gibson mediumgrey break-word">{{proj.description}}</p>
                    </el-collapse-item>
                  </el-collapse>
                  <div class="border-bottom pb2">
                    <div class="pb2"></div>
                    <div class="block">
                      <b-form-input :id="'amount'+proj.projectid" placeholder="Beløb her" class="amount mb1" :min="200" @input="formatAmount(proj.projectid)">
                      </b-form-input>
                      <b-button type="button" class="action-button py2 px3 m0 mb1 gibson not-rounded border-none regular col-12" @click="confirmBoost(proj.projectid, 'facebook')">Boost på facebook <i class="fab fa-facebook-f"></i>
                      </b-button>
                      <b-button type="button" class="action-button py2 px3 m0 gibson not-rounded border-none regular col-12" @click="confirmBoost(proj.projectid, 'google')">Boost på google  <i class="fab fa-google"></i>
                      </b-button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mt3"><span class="bold">{{projMsg}}</span></div>
            </div>
          </div>
          <!-- Boost confirmation modal -->
          <b-modal id="boost-modal" v-model="modalBoostConfirmation" hide-footer centered no-close-on-esc no-close-on-backdrop>
            <div class="center col-10 py3 mx-auto">
              <div class="mb3">
                <img src="static/svg/question-mark-new.svg" rel="preload" width="25%">
              </div>
              <div class="clearfix">
                <p class="darkblue bold m0">Du er ved at booste din profil på <span class="capitalize">{{boostOption}}</span>.</p>
                <p class="darkblue bold mb3">Ønsker du at forsætte?</p>
                <div class="flex justify-between">
                  <b-button type="button" class="primarycolor-background py2 px3 m0 gibson not-rounded border-none regular col-5" @click="modalBoostConfirmation = false">
                    Nej 
                  </b-button>
                  <b-button type="button" class="action-button  py2 px3 m0 gibson not-rounded border-none regular col-5" @click="boostProject(boostProjId, boostOption)">
                    Ja
                  </b-button>
                </div>
              </div>
            </div>
          </b-modal>
          <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import WebshopHeader from './header'
import projectimages from '.././uploads/projectimages'
import Simplert from 'vue2-simplert'
export default {
  name: '',
  components: {
    WebshopHeader,
    projectimages,
    Simplert
  },
  data () {
    return {
      insideLoading: true,
      salesPerson: '',
      haaId: '',
      projData: '',
      projMsg: 'Du Har Ikke Et Projekt.',
      showLess: true,
      boostProjId: '',
      boostOption: '',
      modalBoostConfirmation: false
    }
  },
  created () {
    this.salesPerson = localStorage.getItem('id_token_portal')
    this.haaId = localStorage.getItem('haaid')
    this.displayProjects()
  },
  methods: {
    showlesss (key) {
      this.showLess = !this.showLess
      if (this.showLess) {
        document.querySelector('span[data-key="' + key + '"]').classList.remove('text-overflow-handle')
      } else {
        document.querySelector('span[data-key="' + key + '"]').classList.add('text-overflow-handle')
      }
    },
    displayProjects () {
      var data = {
        operation: 'myProjectnew',
        salesPerson: this.salesPerson,
        levid: this.haaId
      }
      this.$http.post('', data, { emulateJSON: true }).then(
        response => {
          var res = response.body
          var dataRes = res.projects
          this.projData = dataRes
          this.setDefaultAmount()
          if (!dataRes.length) {
            this.projMsg = 'Du Har Ikke Et Projekt.'
          } else {
            this.projMsg = ''
          }
          this.insideLoading = false
        },
        response => {
          this.insideLoading = false
          this.$toastr('error', 'Fejl')
          console.log('Error in displayProjects()')
        }
      )
    },
    setDefaultAmount () {
      setTimeout(function () {
        var amount = document.querySelectorAll('input.amount')
        for (var i = 0; i < amount.length; i++) {
          amount[i].value = '200,00'
        }
      }, 500)
    },
    formatAmount (projId) {
      setTimeout(function () {
        var amount = document.getElementById('amount' + projId).value
        if (amount !== '') {
          if (Number.isInteger(parseInt(amount))) {
            var noDotCommaValue = amount.replace(',00', '').replace(',0', '').replace(',', '').replace('.', '')
            var formatter = new Intl.NumberFormat('da', {
              style: 'currency',
              currency: 'DKK',
              minimumFractionDigits: 2
            })
            document.getElementById('amount' + projId).value = formatter.format(noDotCommaValue).replace('kr.', '').replace(/\s+/g, '')
          } else {
            document.getElementById('amount' + projId).value = ''
          }
        }
      }, 1000)
    },
    confirmBoost (projId, option) {
      this.boostProjId = projId
      this.boostOption = option
      this.modalBoostConfirmation = true
    },
    boostProject (projId, option) {
      const amount = document.getElementById('amount' + projId).value.replace(',00', '').replace(',0', '').replace(',', '').replace('.', '')
      if (amount !== '') {
        if (Number.isInteger(parseInt(amount))) {
          var url = ''
          if (option === 'facebook') {
            url = 'integration/PostProjectToFBAd/' + this.haaId + '/' + projId + '/' + amount
          } else {
            url = 'integration/PostProjectToGoogleAd/' + amount + '/' + projId + '/' + this.haaId
          }
          // // Post Ad
          var data = {
            operation: 'bitrixApi',
            salesPerson: this.salesPerson,
            type: 'POST',
            url: url,
            createinvoice: true,
            price: amount
          }
          this.$http.post('', data, { emulateJSON: true }).then(
            response => {
              var res = response.body
              if (res !== null) {
                if (res.success) {
                  // var adId = ''
                  // var adGroupId = ''
                  // if (option === 'facebook') {
                  //   adId = res.AdId
                  // } else {
                  //   adId = res.Result.AdId
                  //   adGroupId = res.Result.AdGroupId
                  // }
                  // var generatedOrderId = this.haaId + '' + Date.now()
                  // Pause ad
                  // this.stopStartAd(adId, adGroupId, option)
                  this.insideLoading = false
                  this.setDefaultAmount()
                  let obj = {
                    title: 'Dit projekt boost er nu sendt afsted til ' + option + '. Du vil modtage en besked når den er online på ' + option + '.',
                    message: '',
                    type: 'success',
                    customCloseBtnText: 'Luk'
                  }
                  this.$refs.simplert.openSimplert(obj)
                } else {
                  this.insideLoading = false
                  this.setDefaultAmount()
                  this.$toastr('error', 'Fejl')
                  console.log('Error in boostProject()', response)
                }
              } else {
                this.insideLoading = false
                this.setDefaultAmount()
                this.$toastr('error', 'Allerede boostet')
                console.log('Error in boostProject()', response)
              }
            },
            response => {
              this.insideLoading = false
              this.setDefaultAmount()
              this.$toastr('error', 'Fejl')
              console.log('Error in boostProject()', response)
            }
          )
          this.modalBoostConfirmation = false
          this.insideLoading = true
        } else {
          this.$toastr('error', 'Ugyldigt beløb')
        }
      } else {
        this.$toastr('error', 'Indtast beløb')
      }
    }
    // validatePayment (adId, orderId, amount, option) {
    //   var data = {
    //     createinvoice: true,
    //     orderid: orderId,
    //     price: amount
    //   }
    //   this.$http.post('https://www.kundematch.dk/crm/libraries/productform/product.php?mode=checkinvoice&addsid=' + adId, data, { emulateJSON: true }).then(
    //     (response) => {
    //       var res = response.body
    //       // If paid
    //       if (res.result.paid) {
    //         console.log(res)
    //         this.insideLoading = false
    //         this.$toastr('success', 'Gennemført')
    //       } else {
    //         // If not
    //         this.stopStartAd(adId, option)
    //       }
    //     },
    //     (response) => {
    //       console.log('Error in validatePayment')
    //       this.insideLoading = false
    //     }
    //   )
    // },
    // stopStartAd (adId, adGroupId, option) {
    //   var url = ''
    //   if (option === 'facebook') {
    //     url = 'integration/PauseFbAd/' + adId
    //   } else {
    //     url = 'integration/PauseGoogleAd/' + adId + '/' + adGroupId
    //   }
    //   var data = {
    //     operation: 'bitrixApi',
    //     salesPerson: this.salesPerson,
    //     type: 'POST',
    //     url: url
    //   }
    //   this.$http.post('', data, { emulateJSON: true }).then(
    //     (response) => {
    //       var res = response.body
    //       if (res.success) {
    //         this.insideLoading = false
    //         this.setDefaultAmount()
    //         this.$toastr('success', 'Gennemført')
    //       } else {
    //         this.insideLoading = false
    //         this.setDefaultAmount()
    //         this.$toastr('error', 'Fejl')
    //         console.log('Error in stopStartAd()', response)
    //       }
    //     },
    //     (response) => {
    //       this.insideLoading = false
    //       this.setDefaultAmount()
    //       this.$toastr('error', 'Fejl')
    //       console.log('Error in stopStartAd()', response)
    //     }
    //   )
    // }
  }
}
</script>
<style>
.text-overflow-handle {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis
}

  #boost-projekt .el-collapse-item .el-collapse-item__header {
    font-size: 1rem;
    font-weight: bold;
    border: none;
    color: #003645;
  }
/*  #boost-projekt .el-collapse-item .el-collapse-item__header:before {
    font-family: element-icons!important;
    content: "\E75E";
    font-size: 1.5rem;
    font-weight: normal;
    margin-right: 1rem;
  }*/
  #boost-projekt .el-collapse-item__content {
    font-size: 1rem; 
  }
   #boost-projekt .el-collapse-item .el-collapse-item__wrap {
    border-bottom: none;
   }
   @media (max-width: 64em) {
    #boost-projekt .col-12.flex > div.lg-col-3 {
      padding-right: 0;
    }
  }
</style>


// WEBPACK FOOTER //
// BoostProjekt.vue?58383a18